import React, { useRef, useState } from "react";
import { Box, Typography, Divider, Grid, Button } from "@mui/material";
// import logo from "../assets/logo-round-jmk.png"
import "../custom-css/print.css";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadCertificatePDF } from "../utils/experiencePDF";
import { printHtml } from "../utils/htmlToPrint";

const PaymentReceipt = ({ currency = "₹" }) => {

  const [showPrintButton, setShowPrintButton] = useState(true);
  const receiptRef = useRef();
  const location = useLocation();
  const { receiptData } = location.state || {};
  const navigate = useNavigate();

  // const handlePrint = () => {
  //   printHtml('payment');
  //   setTimeout(() => {
  //     window.location.reload();
  //     navigate(-1);
  //   }, 500);
  // };

  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };
const cell = { border: "1px solid #000", padding: "8px" }

  return (

    <div ref={receiptRef} className="receipt">
      <div id="payment">
        <Box
          sx={{
            maxWidth: "800px",
            margin: "auto",
            px: 4,
            pb: 4,
            border: "2px solid #e6e6e6ff",
            borderRadius: "12px",
            backgroundColor: "#fff",
          }}
        >
          {/* Header with Logo */}
          <Box display="flex" alignItems="center" justifyContent="flex-start" flexDirection={'column'}>
            <img
              src={receiptData?.logo} // replace with your logo path
              alt="School Logo"
              style={{ width: 80, height: 70 }}
            />
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              {receiptData?.schoolName}
            </Typography>
            <Typography variant="caption" sx={{ pb: 1 }}>
              {receiptData?.address}
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption">
              Receipt No: <b>{receiptData?.receiptNumber}</b>
            </Typography>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Student & Payment Info */}
          <Grid container spacing={2} display="flex" justifyContent="space-between">
            <Grid item xs={6}>
              <Typography variant="body2"><b>Student Name:</b> {toCamelCase(receiptData?.studentName)}</Typography>
              <Typography variant="body2"><b>Standard:</b> {receiptData?.standard}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2"><b>Payment Mode:</b> {receiptData?.paymentMode}</Typography>
              <Typography variant="body2"><b>Date:</b> {receiptData?.paymentDate}</Typography>
              {receiptData?.remark && (
                <Typography variant="body2"><b>Remark:</b> {receiptData?.remark}</Typography>
              )}
            </Grid>
          </Grid>

          <Divider sx={{ my: 1 }} />

          {/* Fee Details Table */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f0f0f0" , fontSize:"14px" }}>
                <th style={cell}>#</th>
                <th style={cell}>Fee Type</th>
                <th style={cell}>Amount ({currency})</th>
              </tr>
            </thead>
            <tbody>
              {receiptData?.fees?.map((fee, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>
                    {index + 1}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>{toCamelCase(fee.feeType)}</td>
                  <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                    {currency} {Number(fee.amount || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#f9f9f9" }}>
                <td colSpan="2" style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                  <b>Total</b>
                </td>
                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                  <b>
                    {currency}{" "}
                    {receiptData?.fees.reduce((sum, fee) => sum + Number(fee.amount || 0), 0).toFixed(2)}
                  </b>
                </td>
              </tr>
            </tfoot>
          </table>

          {/* Footer */}
          <Box mt={4} display="flex" justifyContent="space-between">
            <Typography variant="body2">Authorized By: _____________</Typography>
            <Typography variant="body2">Signature: _____________</Typography>
          </Box>
        </Box>
      </div>

      {/* Print Button */}
      {showPrintButton && (
        <Box textAlign="center" mt={3}>
          <Button variant="contained" sx={{ bgcolor: "#3f2d01", borderRadius: 5, mr:4 }} onClick={()=> {printHtml("payment"); window.location.reload()}}>
            Print Receipt
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setTimeout(() => {
                downloadCertificatePDF("payment", `${receiptData.receiptNumber}` + ".pdf");
                setShowPrintButton(true);
                navigate(-1);
              }, 100);
            }}
          >
            Download PDF
          </Button>
        </Box>
      )}
    </div >
  );
};

export default PaymentReceipt;
